import React from 'react';
import {get, isEmpty} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

interface OrderDateItem {
  orderDate?: string;
}

interface OrderDateProps {
  tt: (key: string, callback: any) => string;
  item: OrderDateItem;
}

export const OrderDate: React.FC<OrderDateProps> = ({tt, item = {}}) => {
  const orderDate = get(item, 'orderDate', '');
  return (
    <Text
      testID={Reports.reportClientLastOrderedDate}
      allowFontScaling
      maxFontSizeMultiplier={2}>
      {isEmpty(orderDate)
        ? tt('noOrders', 'No Orders Yet')
        : tt(
            'orderDate',
            generateComponentCallback({
              component: (
                <>
                  Last Ordered{' '}
                  {getDateUtilDefaultInstance().formatDate(
                    orderDate,
                    'MMMM d, yyyy',
                  )}
                </>
              ),
            }),
          )}
    </Text>
  );
};

export default withTranslation('report.record.orderDate')(OrderDate);
